<!-- <div class="card card-outline card-primary">
    <div class="card-header text-center">
        <a [routerLink]="['/']" class="h4"><b>منصة تصحيح المخططات</b></a>
    </div>
    <div class="card-body">
        <p class="login-box-msg">أدخل بيانات الدخول</p>

        <form [formGroup]="loginForm" (ngSubmit)="loginByAuth()">
            <div class="input-group mb-3">
                <input
                    formControlName="username"
                    type="text"
                    class="form-control"
                    placeholder="اسم المستخدم"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-user"></span>
                    </div>
                </div>
            </div>
            <div class="input-group mb-3">
                <input
                    formControlName="password"
                    type="password"
                    class="form-control"
                    placeholder="كلمة المرور"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-lock"></span>
                    </div>
                </div>
            </div>
            <div class="input-group mb-3">
                <select class="custom-select" formControlName="role">
                    <option value="viewer">عرض إحصائيات</option>
                    <option value="editor-user">مستخدم لتعديل قطع الأراضي</option>
                    <option value="engineer">مهندس</option>
                    <option value="systemadmin">مسئول النظام</option>
                </select>
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-act">كـ</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-7">
                    <div class="icheck-primary">
                        <input type="checkbox" id="remember" />
                        <label for="remember"> تذكرني </label>
                    </div>
                </div> 
                <div class="col-5">
                    <pf-button
                        [variant]="'primary'"
                        [loading]="isAuthLoading"
                        [disabled]="isFacebookLoading || isGoogleLoading"
                        (click)="loginByAuth()"
                    >
                        تسجيل الدخول
                    </pf-button>
                </div> 
            </div>
        </form>
 
        <p class="mb-1">
            <a [routerLink]="['/forgot-password']">نسيت كلمة المرور</a>
        </p>
  
    </div> 
</div> -->
<section class="flex w-full h-dvh" style="direction: rtl; text-align: start;">
    <form [formGroup]="loginForm" (ngSubmit)="loginByAuth()"
        class="w-[40%] animate-flip-up animate-once gap-5 p-5 flex flex-col justify-center"
    >
        <h2 class="text-3xl font-bold mt-[20%]">اهلاً بعودتك</h2>
        <br />
        <label>تسجيل الدخول</label>
        <input
            formControlName="username"
            type="email"
            placeholder="ادخل اسم المستخدم "
            class="input-tw"
        />
        <label> كلمة المرور</label>
        <div class="relative w-full">
            <input
                formControlName="password"
                type="password"
                #passInput
                placeholder="ادخل كلمة المرور"
                class="input-tw w-full"
            />
            <button
                (click)="
                    passInput.type =
                        passInput.type === 'password' ? 'text' : 'password'
                "
                class="absolute top-0 bottom-0 left-3"
            >
                <img src="./assets/images/Vector.png" class="h-4" />
            </button>
        </div>
        <select class="custom-select" [value]="'systemadmin'" formControlName="role">
                    <option value="viewer">عرض إحصائيات</option>
                    <option value="editor-user">مستخدم لتعديل قطع الأراضي</option>
                    <option value="engineer">مهندس</option>
                    <option value="systemadmin">مسئول النظام</option>
                </select>
        <div class="flex justify-between">
            <a class="text-blue-600 underline">نسيت كلمة السر ؟</a>
            <div
                (click)="this.remmberMe = !this.remmberMe"
                class="switch-tw relative"
            >
                <div
                    [class]="
                        'absolute size-5 transition-all duration-300 mx-1 rounded-full drop-shadow-lg ' +
                        (this.remmberMe
                            ? ' -translate-x-full  bg-main-color  '
                            : ' bg-white  ')
                    "
                ></div>
            </div>
        </div>
        <button
            [disabled]="isAuthLoading"
            (click)="loginByAuth()"
            type="submit"
            class="btn-tw"
        >
            تسجيل الدخول
        </button>
        <img
            src="./assets/images/Group 1171275299.png"
            class="w-[250px] m-auto"
        />
    </form>
    <div class="w-[60%] bg-slate-600">
        <img
            class="object-cover h-full w-full animate-fade animate-once"
            src="./assets/63c0b4bdf824c65b1439f5152378213a.jfif"
        />
    </div>
</section>
